import {
  GAME_ID,
  ROUND_STATUSES,
  MASTERY_PERCENTAGE,
  QUESTIONS_PER_LEVEL,
} from 'a/grumpyGoblins/data/constants';

import { persistStateTypes } from 'a/reducers/persistStateReducer';

const initialState = {
  progress: 0,
  currentLevel: 0,
  highestLevelListView: 0,
  mastery: 0,
  practiceIndices: {
    ch: -1,
    qu: -1,
    th: -1,
    ng: -1,
    ee: -1,
    oo: -1,
    sh: -1,
    ou: -1,
    aw: -1,
    er: -1,
    ck: -1,
    ow: -1,
    oi: -1,
    ar: -1,
    tch: -1,
    wr: -1,
    or: -1,
    ai: -1,
    kn: -1,
    wh: -1,
    ay: -1,
    oy: -1,
    igh: -1,
    al: -1,
    ph: -1,
    ea: -1,
    ir: -1,
    ol: -1,
    au: -1,
  },
  currentPracticeItem: null,
  toastImage: 'defaultToastKey',
  goblinImage: 'defaultGoblinKey',

  isOnboardingCompleted: false, // true, if user already completed first time onboarding

  // metadata local props
  currentLevelId: null,
  currentRoundStatus: null,
  highestLevelEarned: 0,
};

const gameDetailsReducer = (state = initialState, { gameId, type, payload, stateData }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case 'GRUMPY_GOBLINS_INCREMENT_PROGRESS':
      return {
        ...state,
        progress: payload,
      };

    case 'GRUMPY_GOBLINS_UPDATE_CURRENT_LEVEL':
      return {
        ...state,
        currentLevel: payload,
      };

    case 'GRUMPY_GOBLINS_UPDATE_HIGHEST_LIST_VIEW': {
      return {
        ...state,
        highestLevelListView: payload,
      };
    }

    case 'GRUMPY_GOBLINS_SET_MASTERY':
      return {
        ...state,
        mastery: payload,
      };

    case 'GRUMPY_GOBLINS_UPDATE_PRACTICE_ROUND': {
      // each new time a specific sound needs to be practiced,
      // queue up a new practice item. Loop as necessary.
      const { practiceIndices } = state;
      if (practiceIndices[payload] < 3) {
        practiceIndices[payload]++;
      } else {
        practiceIndices[payload] = 0;
      }
      return {
        ...state,
        currentPracticeItem: payload,
        practiceIndices,
      };
    }

    case persistStateTypes.REQUESTRESPONSE_GAMESTATE: {
      const gameData = {
        ...initialState,
        ...stateData[GAME_ID].GameData,
      };

      gameData.isOnboardingCompleted = !!gameData.isOnboardingCompleted;

      return gameData;
    }

    case 'GRUMPY_GOBLINS_START_STANDARD_ROUND': {
      const { currentLevelId } = payload;

      return {
        ...state,
        currentLevelId,
        currentRoundStatus: ROUND_STATUSES.ROUND_STARTED,
      };
    }

    case 'GRUMPY_GOBLINS_INTERRUPT_STANDARD_ROUND': {
      return {
        ...state,
        mastery: 0,
        currentLevelId: null,
        currentRoundStatus: ROUND_STATUSES.ROUND_INTERRUPTED,
      };
    }

    case 'GRUMPY_GOBLINS_COMPLETE_STANDARD_ROUND': {
      let listViewProgress = state.highestLevelListView;
      if (state.highestLevelListView < payload &&
        (state.mastery / QUESTIONS_PER_LEVEL) > MASTERY_PERCENTAGE) listViewProgress++;
      return {
        ...state,
        mastery: 0,
        currentLevelId: null,
        currentRoundStatus: ROUND_STATUSES.ROUND_COMPLETED,
        highestLevelListView: listViewProgress,
      };
    }

    case 'GRUMPY_GOBLINS_UPDATE_ONBOARDING_METADATA': {
      return {
        ...state,
        isOnboardingCompleted: true,
      };
    }

    case 'GRUMPY_GOBLINS_QUICK_ROUND': {
      const numCorrect = payload ? QUESTIONS_PER_LEVEL : 0;
      return {
        ...state,
        mastery: numCorrect,
        progress: QUESTIONS_PER_LEVEL,
      };
    }

    default:
      return state;
  }
};

export default gameDetailsReducer;
